import React from 'react';

const DocumentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4667_16458)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5003 5.83333H2.50033C2.04033 5.83333 1.66699 5.46 1.66699 5V3.33333C1.66699 2.87333 2.04033 2.5 2.50033 2.5H17.5003C17.9603 2.5 18.3337 2.87333 18.3337 3.33333V5C18.3337 5.46 17.9603 5.83333 17.5003 5.83333Z"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.5 9.16667H12.5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.2223 5.83325V15.8333C17.2223 16.7541 16.4765 17.4999 15.5557 17.4999H4.44401C3.52318 17.4999 2.77734 16.7541 2.77734 15.8333V5.83325"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4667_16458">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DocumentIcon;
